import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Common from "../../helpers/common";
import { PhoneInputField } from "../formik-components";
import { VerificationTypeEnum, respEnum } from "../../constants/appConstants";
import Swal from "sweetalert2";

const forgotPasswordSchema = Yup.object().shape({
  phone: Yup.string().required("Phone number is required"),
});

const ForgotPasswordModal = ({ onClose, onOtpNavigation, onBackToLogin }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      Common.ApiService.getInstance().initialize(
        Common.AppConstant.serviceUrl,
        {
          "Content-Type": "application/json",
        }
      );

      const response = await Common.ApiService.getInstance()?.request(
        "SendVerificationCode",
        {
          phoneCode: values.phoneCode,
          phone: values.phoneNum,
          deviceId: "string",
          type: VerificationTypeEnum.forgotPassword,
        },
        "POST"
      );

      if (response?.status == respEnum.Success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "OTP sent successfully",
          background: "#1a1a1a",
          color: "#fff",
          confirmButtonColor: "#007bff",
        });
        // Navigate to OTP modal with forgot password context and start timer immediately
        onOtpNavigation({
          phoneCode: values.phoneCode,
          phone: values.phoneNum,
          verificationType: VerificationTypeEnum.forgotPassword,
          startTimer: true, // Flag to start timer immediately
        });
      } else {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.message || "Failed to send OTP",
          background: "#1a1a1a",
          color: "#fff",
          confirmButtonColor: "#007bff",
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to send OTP. Please try again.",
        background: "#1a1a1a",
        color: "#fff",
        confirmButtonColor: "#007bff",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="popup">
      <div
        className="popup-inner"
        style={{
          backgroundColor: "#1a1a1a",
          color: "white",
          top: "50%",
          border: "1px solid",
          maxWidth: "400px",
          width: "90%",
          boxShadow: "0 0 20px rgba(255, 255, 255, 0.1)",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            right: "15px",
            top: "15px",
            background: "none",
            border: "none",
            color: "white",
            fontSize: "28px",
            cursor: "pointer",
            padding: "5px 10px",
            lineHeight: "1",
            zIndex: "1000",
          }}
        >
          ×
        </button>

        <div
          style={{
            textAlign: "center",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >
          <img
            src="/images/logo_white.svg"
            alt="Ignite Sports"
            style={{
              width: "120px",
              height: "auto",
            }}
          />
        </div>

        <h2
          style={{
            textAlign: "center",
            color: "white",
            marginBottom: "6px",
            fontSize: "28px",
            fontWeight: "bold",
          }}
        >
          Forgot Password
        </h2>

        <p
          style={{
            textAlign: "center",
            color: "#999",
            marginBottom: "20px",
            fontSize: "14px",
          }}
        >
          Enter your phone number to receive a verification code
        </p>

        <Formik
          initialValues={{
            phone: "",
            phoneCode: "",
            phoneNum: "",
          }}
          validationSchema={forgotPasswordSchema}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (
            <form onSubmit={formikProps.handleSubmit}>
              <div style={{ marginBottom: "20px" }}>
                <PhoneInputField formikProps={formikProps} />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                style={{
                  width: "100%",
                  backgroundColor: "white",
                  color: "black",
                  marginTop: "25px",
                  padding: "4px",
                  borderRadius: "4px",
                  border: "none",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#e6e6e6")
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = "white")}
              >
                {isLoading ? "Sending..." : "Send Verification Code"}
              </button>

              <div
                style={{
                  textAlign: "center",
                  marginTop: "25px",
                  color: "#999",
                }}
              >
                Remember your password?{" "}
                <button
                  type="button"
                  onClick={onBackToLogin || onClose}
                  style={{
                    background: "none",
                    border: "none",
                    color: "white",
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontSize: "14px",
                  }}
                >
                  Back to Login
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
